import React from 'react'

const Credits = () => {
    return (
        <>
            <div class="main column col">
            <div class="banner mt-1">
                <img class="image-fluid" src="./images/Pipeflare-promo-banner_728x90.jpg" width="100%" alt="" />
            </div>

            
            <div class="container mt-5">
                
                    <div class="credits-header">
                        <h1 class="display-4 ">Credits</h1>
                        <small class="text-muted">
                            Credit to the respective owners!
                        </small>
                    </div>
                    <div class="row">
                        <div class="w-100 mt-5">

                            <div class="d-flex credits  mb-4">
                                <div class="w-50 credit-left">
                                    <div class="credit-text pt-3">
                                        <h1>Coin Mining</h1>
                                        <p class="text-muted">
                                            coinmining.png
                                        </p>
                                        <p>
                                            <a href="https://pngtree.com/so/stereoscopic" target="_blank" class="tfx-1">
                                                <span>Got To Link!</span>
                                            </a>
                                        </p>
                                    </div>
                                </div>
                                <div class="w-50 credit-right">
                                    <div class="credit-image w-50">
                                            <img src="./images/coinmining.png" width="100%" alt="Coin Mining"/>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="d-flex credits  mb-4">
                                <div class="w-50 credit-left">
                                    <div class="credit-text pt-3">
                                        <h1>PTC Ads</h1>
                                        <p class="text-muted">
                                            ptc-ads.png
                                        </p>
                                        <p>
                                            <a href="https://pnghut.com/png/1605QXEQpr/pay-per-click-digital-marketing-online-advertising-google-ads-transparent-png#" target="_blank" class="tfx-1">
                                                <span>Got To Link!</span>
                                            </a>
                                        </p>
                                    </div>
                                </div>
                                <div class="w-50 credit-right">
                                    <div class="credit-image w-50">
                                            <img src="./images/ptc-ads.png" width="100%" alt="PTC Ads"/>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="d-flex credits  mb-4">
                                <div class="w-50 credit-left">
                                    <div class="credit-text pt-3">
                                        <h1>Survey</h1>
                                        <p class="text-muted">
                                            survey.png
                                        </p>
                                        <p>
                                            <a href="https://www.kindpng.com/imgv/iixmhmR_survey-icon-png-circle-png-download-survey-png/" target="_blank" class="tfx-1">
                                                <span>Got To Link!</span>
                                            </a>
                                        </p>
                                    </div>
                                </div>
                                <div class="w-50 credit-right">
                                    <div class="credit-image w-50">
                                            <img src="./images/survey.png" width="100%" alt="Survey"/>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="d-flex credits  mb-4">
                                <div class="w-50 credit-left">
                                    <div class="credit-text pt-3">
                                        <h1>Trading</h1>
                                        <p class="text-muted">
                                            trading.png
                                        </p>
                                        <p>
                                            <a href="https://www.cleanpng.com/png-trader-foreign-exchange-market-commodity-trading-a-3169224/download-png.html" target="_blank" class="tfx-1">
                                                <span>Got To Link!</span>
                                            </a>
                                        </p>
                                    </div>
                                </div>
                                <div class="w-50 credit-right">
                                    <div class="credit-image w-50">
                                            <img src="./images/trading.png" width="100%" alt="Trading"/>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="d-flex credits  mb-4">
                                <div class="w-50 credit-left">
                                    <div class="credit-text pt-3">
                                        <h1>Cloud Mining</h1>
                                        <p class="text-muted">
                                            cloud-mining.png
                                        </p>
                                        <p>
                                            <a href="https://pngtree.com/so/laptop-icons" target="_blank" class="tfx-1">
                                                <span>Got To Link!</span>
                                            </a>
                                        </p>
                                    </div>
                                </div>
                                <div class="w-50 credit-right">
                                    <div class="credit-image w-50">
                                            <img src="./images/cloud-mining.png" width="100%" alt="Cloud Mining"/>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

            </div>
        </div>  
        </>
    )
}

export default Credits;